import type {
  FeatureLoaderOptions,
  FeatureProviderContext,
} from "@origin-digital/features";
import { REDIRECT_TO_BUNDLE_CUSTOMISATION } from "./feature.toggle.list";

export const getFeatureProviderConfig = ({
  env,
  toggleEnv,
}: Pick<IAppConfig, "env" | "toggleEnv">): FeatureLoaderOptions => ({
  environment: toggleEnv,
  ...(env === "local"
    ? {
        localMode: {
          features: {
            [REDIRECT_TO_BUNDLE_CUSTOMISATION]: true,
          },
        },
      }
    : {}),
});

export const isFeatureEnabled = (
  featureContext: Pick<FeatureProviderContext, "features"> | undefined,
  featureName: string
) =>
  featureContext?.features.some(
    ({ name, enabled }) => name === featureName && enabled
  ) ?? false;
